import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_yt389vxcen: FaireCollectionEntity = {
  token: "pbc_yt389vxcen",
  type: "collection",
  name: "Pre-Order / Backorder FW26 Joyful Blankets, Toys & Gift Sets",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f36d7c0b80bfed438da571a1a46e0dec007e0efedebd26c82000ee4db438fe9c.jpeg",
  itemCount: 3,
  description:
    "Ships between Aug 15 - Dec 1 | Thoughtfully crafted organic blankets, toys, and gift sets designed to comfort, delight, and celebrate special moments. Handmade in India with heirloom-quality craftsmanship.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:17.361Z",
    importedBy: "entity-db-import-collections",
  },
};
